import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed, ref } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryMessages',
    props: {
        history: null
    },
    setup(__props) {
        const props = __props;
        const userOverQuota = ref(false);
        const hasMessages = computed(() => {
            return userOverQuota.value || props.history.deleted;
        });
        return { __sfc: true, props, userOverQuota, hasMessages, BAlert, localize };
    }
});
